/* ESTIMATE */

if (!customElements.get('custom-estimate')) {
  class CustomEstimate extends HTMLElement {
    constructor() {
      super();
      // Define app url
      this.appURL = "https://enexo-pro-app-devis-uuc9r.ondigitalocean.app";

      // Define used elements
      // General elems
      this.bodyElem = document.querySelector("html");
      this.closeButton = this.querySelector(".close_estimate");
      this.background = this.querySelector(".background_full");
      this.goBackButton = this.querySelector(".go_back_estimate");
      // No customer elems
      this.createCustomerLink = this.querySelector("#create_customer_link");
      this.changeUserButton = this.querySelector("#changeUser");
      this.continueButton = this.querySelector("#continue_btn");
      this.emailError = this.querySelector("#email_error");
      this.emailNotB2b = this.querySelector("#email_not_b2b");
      this.emailNotValid = this.querySelector("#email_not_valid");
      this.emailUnknowError = this.querySelector("#email_unknow_error");
      // Cart create customer elems
      this.createCustomerLinkCart = this.querySelector("#cart_create_customer_link");
      this.continueButtonCart = this.querySelector("#cart_continue_btn");
      this.emailErrorCart = this.querySelector("#cart_email_error");
      this.emailNotB2bCart = this.querySelector("#cart_email_not_b2b");
      this.emailNotValidCart = this.querySelector("#cart_email_not_valid");
      this.emailUnknowErrorCart = this.querySelector("#cart_email_unknow_error");
      // Estimate form elems
      this.estimateForm = this.querySelector(".estimate_cart form");
      this.submitEstimateButton = this.querySelector(".estimate_cart form button[type='submit']");
      this.estimateCartProductWrapper = this.querySelector(".estimate_cart .estimate_product_wrapper");
      this.finalCloseButton = this.querySelector("#final_close_button");
      // Create customer elems
      this.createCustomerForm = this.querySelector(".estimate_create_customer form");
      this.createCustomerSameAddressCheckbox = this.querySelector(".estimate_create_customer #billing-address-same-address-input");
      this.submitCustomerButton = this.querySelector(".estimate_create_customer form button[type='submit']");
      this.billingAddressCountryInput = $("#billing-address-country-input");
      this.shippingAddressCountryInput = $("#shipping-address-country-input")
      this.accountCloseButton = this.querySelector("#close_button_account");
      // Init country select
      this.billingAddressCountryInput.countrySelect({
        defaultCountry: "fr",
        preferredCountries: ["fr", "be", "ch", "de", "it", "es", "gb"]
      });
      this.shippingAddressCountryInput.countrySelect({
        defaultCountry: "fr",
        preferredCountries: ["fr", "be", "ch", "de", "it", "es", "gb"]
      });

      // Used variables
      this.hasSent = false;
      this.isCartPage = false;

      // If not connected and no customer in cookie, display estimate section
      if (this.goBackButton && Cookie.get("customer_email") && Cookie.get("customer_id")) {
        this.goToEstimate(Cookie.get("customer_id"), Cookie.get("customer_email"));
      }

      this.addEvents();
    }

    // Add cart page button open estimate event
    addCartPageOpenEstimateEvent() {
      const cartPageEstimateButton = document.querySelector("#cart #cart-summary .btn-estimate");
      console.log('addCartPageOpenEstimateEvent')
      if (cartPageEstimateButton) {
        cartPageEstimateButton.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('click addCartPageOpenEstimateEvent')
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            'event': 'devis_click',
            'category': 'button',
            'action': 'click',
            'label': 'devis'
          });
          console.log('window data layer: ', window.dataLayer)
          this.style.display = "block";
          this.querySelector(".estimate_no_customer").style.display = "block";
          this.querySelector(".estimate_create_customer").style.display = "none";
          this.querySelector(".estimate_content").style.display = "none";
          this.querySelector(".estimate_create_customer_cart").style.display = "none";
          this.bodyElem.style.overflow = "hidden";
        });
      }
    }

    // Add cart page button open estimate account event
    addCartPageOpenEstimateAccountEvent() {
      const cartPageEstimateAccountButton = document.querySelector("#cart #cart-summary .btn-estimate-account");
      console.log('addCartPageOpenEstimateAccountEvent')
      if (cartPageEstimateAccountButton) {
        cartPageEstimateAccountButton.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('click addCartPageOpenEstimateAccountEvent')
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            'event': 'devis_click',
            'category': 'button',
            'action': 'click',
            'label': 'devis'
          });
          console.log('window data layer: ', window.dataLayer);

          this.isCartPage = true;
          this.style.display = "block";
          this.querySelector(".estimate_no_customer").style.display = "none";
          this.querySelector(".estimate_create_customer").style.display = "none";
          this.querySelector(".estimate_content").style.display = "none";
          this.querySelector(".estimate_create_customer_cart").style.display = "block";
          this.bodyElem.style.overflow = "hidden";
        });
      }
    }

    // Add drawer cart button open estimate event (need to trigger it every times drawer reset)
    addCartOpenEstimateEvent() {
      const cartEstimateButton = document.querySelector(".cart-drawer__checkout-buttons .btn-estimate");
      console.log('addCartOpenEstimateEvent')
      if (cartEstimateButton) {
        cartEstimateButton.addEventListener("click", (e) => {
          console.log('addCartOpenEstimateEvent click')
          e.preventDefault();
          e.stopPropagation();
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            'event': 'devis_click',
            'category': 'button',
            'action': 'click',
            'label': 'devis'
          });
          console.log('window data layer: ', window.dataLayer)
          this.style.display = "block";
          this.bodyElem.style.overflow = "hidden";
        });
      }
    }

    // Go to estimate section
    goToEstimate(customerId, customerEmail) {
      console.log('goToEstimate')
      // Fill email input
      this.querySelector(".estimate_cart input[name='customer_id']").value = customerId;
      this.querySelector(".estimate_cart input[name='customer_email']").value = customerEmail;
      if (this.querySelector("#estimate-email-cookie")) {
        this.querySelector("#estimate-email-cookie").innerText = customerEmail;
      }

      // Display next step
      this.continueButton.classList.remove("is-loading");
      this.emailError.style.display = "none";
      this.emailNotValid.style.display = "none";
      this.emailUnknowError.style.display = "none";

      this.querySelector(".estimate_no_customer").style.display = "none";
      this.querySelector(".estimate_create_customer").style.display = "none";
      this.querySelector(".estimate_content").style.display = "block";
      if (this.goBackButton) {
        this.goBackButton.style.display = "block";
      }
    }

    // Go back to no customer section
    goBack() {
      this.querySelector(".estimate_no_customer").style.display = "block";
      this.querySelector(".estimate_create_customer").style.display = "none";
      this.querySelector(".estimate_content").style.display = "none";
      this.goBackButton.style.display = "none";

      // Remove customer from cookie
      Cookie.remove("customer_id");
      Cookie.remove("customer_email");
    }

    // Event listeners handlers
    addEvents() {
      // Close estimate section
      this.background.addEventListener("click", this.closeEstimate.bind(this));
      this.closeButton.addEventListener("click", this.closeEstimate.bind(this));
      this.finalCloseButton.addEventListener("click", this.closeEstimate.bind(this));
      this.accountCloseButton.addEventListener("click", this.closeEstimate.bind(this));

      this.addCartPageOpenEstimateEvent();
      this.addCartPageOpenEstimateAccountEvent();
      this.addCartOpenEstimateEvent();

      // Go back button
      if (this.goBackButton) {
        this.goBackButton.addEventListener("click", this.goBack.bind(this));
      }

      // Change user button (same as go back)
      if (this.changeUserButton) {
        this.changeUserButton.addEventListener("click", this.goBack.bind(this));
      }

      // Populate estimate cart item with cart content on cart change
      document.addEventListener('on:cart:add', this.populateEstimateCartItem.bind(this));
      document.addEventListener('on:line-item:change', this.populateEstimateCartItem.bind(this));

      // Add oppening estimate event on cart button when drawer open to be sure html exist
      document.addEventListener("on:cart-drawer:before-open", this.addCartOpenEstimateEvent.bind(this));
      //document.addEventListener("cart-drawer:open", this.addCartOpenEstimateEvent.bind(this));
      

      // Handle no customer continue button
      this.continueButton.addEventListener("click", async () => {
        // If already loading, do nothing
        if (this.continueButton.classList.contains("is-loading")) {
          return;
        }
        this.continueButton.classList.add("is-loading");

        // Reset email errors
        this.emailNotValid.style.display = "none";
        this.emailError.style.display = "none";
        this.emailNotB2b.style.display = "none";
        this.emailUnknowError.style.display = "none";

        // Get email
        const email = this.querySelector("#estimate-email-input").value;
        const emailValid = this.querySelector("#estimate-email-input").validity.valid;

        // Check if email is valid
        if (!emailValid) {
          this.emailNotValid.style.display = "block";
          this.continueButton.classList.remove("is-loading");
          return;
        }

        // Check if customer exist
        try {
          const response = await fetch(`${this.appURL}/customer?email=${email}`);
          const customer = await response.json();
          console.log("CUSTOMER", customer)

          // If no customer, display error
          if (!customer) {
            this.emailError.style.display = "block";
            this.continueButton.classList.remove("is-loading");
            return;
          }

          // If customer not B2B, display error
          if (customer.companyContactProfiles.length === 0) {
            this.emailNotB2b.style.display = "block";
            this.continueButton.classList.remove("is-loading");
            return;
          }

          // Set customer in cookie
          Cookie.set("customer_id", customer.id.split("/").pop());
          Cookie.set("customer_email", customer.email);

          this.goToEstimate(customer.id.split("/").pop(), customer.email);
        } catch (error) {
          console.log(error);
          this.emailUnknowError.style.display = "block";
          this.continueButton.classList.remove("is-loading");
        }
      });

      // Handle no customer continue button in cart
      this.continueButtonCart.addEventListener("click", async () => {
        // If already loading, do nothing
        if (this.continueButtonCart.classList.contains("is-loading")) {
          return;
        }
        this.continueButtonCart.classList.add("is-loading");

        // Reset email errors
        this.emailNotValidCart.style.display = "none";
        this.emailErrorCart.style.display = "none";
        this.emailNotB2bCart.style.display = "none";
        this.emailUnknowErrorCart.style.display = "none";

        // Get email
        const email = this.querySelector("#estimate-email-input-cart").value;
        const emailValid = this.querySelector("#estimate-email-input-cart").validity.valid;

        // Check if email is valid
        if (!emailValid) {
          this.emailNotValidCart.style.display = "block";
          this.continueButtonCart.classList.remove("is-loading");
          return;
        }

        // Check if customer exist
        try {
          const response = await fetch(`${this.appURL}/customer?email=${email}`);
          const customer = await response.json();
          console.log("CUSTOMER", customer)

          // If no customer, display error
          if (!customer) {
            this.emailErrorCart.style.display = "block";
            this.continueButtonCart.classList.remove("is-loading");
            return;
          }

          // If customer not B2B, display error
          if (customer.companyContactProfiles.length === 0) {
            this.emailNotB2bCart.style.display = "block";
            this.continueButtonCart.classList.remove("is-loading");
            return;
          }

          // Set customer in cookie
          Cookie.set("customer_id", customer.id.split("/").pop());
          Cookie.set("customer_email", customer.email);

          this.continueButtonCart.classList.remove("is-loading");
          this.closeEstimate();
        } catch (error) {
          console.log(error);
          this.emailUnknowErrorCart.style.display = "block";
          this.continueButtonCart.classList.remove("is-loading");
        }
      });

      // Handle go to create customer section button
      this.createCustomerLink.addEventListener("click", () => {
        this.querySelector(".estimate_no_customer").style.display = "none";
        this.querySelector(".estimate_create_customer").style.display = "block";
        if (this.goBackButton) {
          this.goBackButton.style.display = "block";
        }
      });

      // Handle go to create customer section button in cart
      this.createCustomerLinkCart.addEventListener("click", () => {
        this.querySelector(".estimate_create_customer_cart").style.display = "none";
        this.querySelector(".estimate_create_customer").style.display = "block";
        if (this.goBackButton) {
          this.goBackButton.style.display = "block";
        }
      });

      // Handle same address checkbox
      this.createCustomerSameAddressCheckbox.addEventListener("change", (e) => {
        // Display or hide billing address & add or remove required attribute
        if (e.target.checked) {
          this.querySelector(".estimate_create_customer .billing_address_wrapper").style.display = "none";
          this.querySelector(".estimate_create_customer #billing-address-first-name-input").required = false;
          this.querySelector(".estimate_create_customer #billing-address-last-name-input").required = false;
          this.querySelector(".estimate_create_customer #billing-address-address1-input").required = false;
          this.querySelector(".estimate_create_customer #billing-address-city-input").required = false;
          this.querySelector(".estimate_create_customer #billing-address-phone-input").required = false;
        } else {
          this.querySelector(".estimate_create_customer .billing_address_wrapper").style.display = "block";
          this.querySelector(".estimate_create_customer #billing-address-first-name-input").required = true;
          this.querySelector(".estimate_create_customer #billing-address-last-name-input").required = true;
          this.querySelector(".estimate_create_customer #billing-address-address1-input").required = true;
          this.querySelector(".estimate_create_customer #billing-address-city-input").required = true;
          this.querySelector(".estimate_create_customer #billing-address-phone-input").required = true;
        }
      });

      // Handle create customer form
      this.createCustomerForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        // If already loading, do nothing
        if (this.submitCustomerButton.classList.contains("is-loading")) {
          return;
        }

        // Add class and remove previous error
        this.submitCustomerButton.classList.add("is-loading");
        this.querySelectorAll(".estimate_create_customer .field_error").forEach((elem) => {
          elem.style.display = "none";
        });
        this.querySelector(".estimate_create_customer .account_creation_final_info").style.display = "none";
        this.querySelector(".estimate_create_customer .account_creation_final_info .success_message").style.display = "none";
        this.querySelector(".estimate_create_customer .account_creation_final_info .error_message").style.display = "none";
        this.querySelector(".estimate_create_customer .account_creation_final_info .server_error_message").style.display = "none";
        this.querySelector(".estimate_create_customer #siretMissingError").style.display = "none";

        // Get data
        const data = this.getCustomerFormData(e.target);
        if (!data) {
          this.submitCustomerButton.classList.remove("is-loading");
          return;
        }

        await this.submitCustomer(data);
      });

      // Handle estimate form
      this.estimateForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        // If already loading, do nothing
        if (this.submitEstimateButton.classList.contains("is-loading")) {
          return;
        }

        // Add class and remove previous error
        this.submitEstimateButton.classList.add("is-loading");
        this.querySelector(".estimate_final_info").style.display = "none";
        this.querySelector(".estimate_final_info .success_message").style.display = "none";
        this.querySelector(".estimate_final_info .error_message").style.display = "none";
        
        // Get data
        const data = this.getEstimateFormData(e.target);
        if (!data) {
          this.submitEstimateButton.classList.remove("is-loading");
          return;
        }

        await this.submitEstimate(data);
      });
    }

    // Test wether email is valid format
    validateEmail(email) {
      const emailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/i);
      return emailReg.test(email);
    }

    // Transform price number into string
    priceToString(price) {
      const priceBase = String(price / 100);
      if (priceBase.indexOf(".") === -1) {
        return `${priceBase},00€`;
      }

      const priceStart = priceBase.split('.')[0];
      const priceEnd = priceBase.split('.')[1].padEnd(2, "0");
      return `${priceStart},${priceEnd}€`;
    }

    // Close estimate section
    closeEstimate() {
      this.bodyElem.style.overflow = "auto";
      this.style.display = "none";
      this.classList.remove("object-input-error");
      this.classList.remove("message-input-error");

      if (this.isCartPage) {
        this.querySelector(".estimate_create_customer_cart").style.display = "none";
        this.goBackButton.style.display = "none";
        this.isCartPage = false;
      }

      // If has sent form, reset it
      if (this.hasSent) {
        this.querySelector(".estimate_cart #estimate-message-input").value = "";
        this.querySelector(".estimate_cart #estimate-object-input").value = "";
        this.submitEstimateButton.style.display = "block";
        this.querySelector(".estimate_final_info").style.display = "none";
        this.querySelector(".estimate_final_info .success_message").style.display = "none";
        this.querySelector(".estimate_final_info .error_message").style.display = "none";

        this.hasSent = false;
      }
    }

    // Create html item from cart event
    createHTMLItem(item, i) {
      const priceWasElem = document.querySelector(`#cart-items .cart-item[data-variant-id="${item.variant_id}"] .price__was`);
      let priceWas = "";
      if (priceWasElem) {
        priceWas = priceWasElem.innerText;
      }

      return `
        <div class="estimate_product_info">
          <input type="hidden" name="variantId_${i}" value="${item.variant_id}">

          <div class="card__media relative">
            <div aria-label="${item.title}" class="media block relative js-prod-link" style="padding-top: 100%;">
              <img
                data-srcset="${item.image}&width=320 320w, ${item.image}&width=460 460w, ${item.image}&width=600 600w, ${item.image}&width=700 700w, ${item.image}&width=800 800w, ${item.image}&width=900 900w" data-src="${item.image}&width=460" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20900%20900'%3E%3C/svg%3E" class="no-js-hidden" data-media-id="image_${item.variant_id}" loading="lazy" width="900" height="900" alt="" srcset="${item.image}&width=320 320w, ${item.image}&width=460 460w, ${item.image}&width=600 600w, ${item.image}&width=700 700w, ${item.image}&width=800 800w, ${item.image}&width=900 900w">
              <noscript>
                <img src="${item.image}&width=460"
                  loading="lazy"
                  width="900"
                  height="900"
                  alt="">
              </noscript>
            </div>
          </div>

          <div class="product_infos">
            <h5 class="product-title h5">
              ${item.title}
            </h5>

            <div class="price price--on-sale">
              <div class="price__default">
                <strong class="price__current">${item.final_price ? this.priceToString(item.final_price) : ""}</strong>
                <s class="price__was">${priceWas}</s>
            </div>
            </div>

              
            <quantity-input class="inline-block">
              <label class="label visually-hidden" for="quantity-">Qté</label>
              <div class="qty-input qty-input--combined inline-flex items-center w-full">
                <button type="button" class="qty-input__btn btn btn--minus no-js-hidden is-hidden-desktop" name="minus">
                  <span class="visually-hidden">-</span>
                </button>
                <input type="number" class="qty-input__input input" id="quantity-${i}" name="quantity_${i}" min="1" value="${item.quantity}">
                <button type="button" class="qty-input__btn btn btn--plus no-js-hidden is-hidden-desktop" name="plus">
                  <span class="visually-hidden">+</span>
                </button>
                
                <div class="btn_wrapper is-hidden-mobile">
                  <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus">
                    <span class="visually-hidden">-</span>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" onclick="this.closest('button').click()">
                      <path d="M1.14909 0.732666H10.7065C11.3677 0.732666 11.6983 1.56574 11.2303 2.05396L6.45341 7.04076C6.16368 7.34299 5.69194 7.34299 5.40221 7.04076L0.625341 2.05396C0.157312 1.56574 0.487904 0.732666 1.14909 0.732666Z" fill="#1D1D1F"></path>
                    </svg>
                  </button>
                  <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus">
                    <span class="visually-hidden">+</span>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" onclick="this.closest('button').click()">
                      <path d="M1.14909 0.732666H10.7065C11.3677 0.732666 11.6983 1.56574 11.2303 2.05396L6.45341 7.04076C6.16368 7.34299 5.69194 7.34299 5.40221 7.04076L0.625341 2.05396C0.157312 1.56574 0.487904 0.732666 1.14909 0.732666Z" fill="#1D1D1F"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </quantity-input>
          </div>
        </div>
      `;
    }

    // Handle submit customer
    async submitCustomer(data) {
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }

      try {
        const response = await fetch(`${this.appURL}/customer`, {
          method: "POST",
          body: formData
        });
        const result = await response.json();
        console.log("RESULT", result)

        this.submitCustomerButton.classList.remove("is-loading");

       if (result.company) {
          // Set customer in cookie
          Cookie.set("customer_id", result.company.mainContact.customer.id.split("/").pop());
          Cookie.set("customer_email", result.company.mainContact.customer.email);

          this.goToEstimate(result.company.mainContact.customer.id.split("/").pop(), result.company.mainContact.customer.email);
        } else {
          this.querySelector(".account_creation_final_info .error_message").innerText = "";
          let hasScroll = false;

          // Check errors
          for (const error of result.userErrors) {
            console.log(error);

            if (error.field.indexOf("email") !== -1) {
              if (error.code === "INVALID") {
                this.querySelector(".estimate_create_customer #customerCreationEmailInvalidError").style.display = "block";
              } else if (error.code === "TAKEN") {
                this.querySelector(".estimate_create_customer #customerCreationEmailTakenError").style.display = "block";
              } else {
                this.querySelector(".estimate_create_customer #customerCreationEmailError").innerText = error.message;
                this.querySelector(".estimate_create_customer #customerCreationEmailError").style.display = "block";
              }

              if (!hasScroll) {
                this.querySelector(".estimate_create_customer #customer-email-input").scrollIntoView({ behavior: "smooth" });
                hasScroll = true;
              }
            } else if (error.field.indexOf("phone") !== -1) {
              if (error.field.indexOf("companyContact") !== -1) {
                if (error.code === "INVALID") {
                  this.querySelector(".estimate_create_customer #companyContactPhoneInvalidError").style.display = "block";
                } else if (error.code === "TAKEN") {
                  this.querySelector(".estimate_create_customer #companyContactPhoneTakenError").style.display = "block";
                } else {
                  this.querySelector(".estimate_create_customer #companyContactPhoneError").innerText = error.message;
                  this.querySelector(".estimate_create_customer #companyContactPhoneError").style.display = "block";
                }

                if (!hasScroll) {
                  this.querySelector(".estimate_create_customer #customer-phone-input").scrollIntoView({ behavior: "smooth" });
                  hasScroll = true;
                }
              } else if (error.field.indexOf("shippingAddress") !== -1) {
                if (error.code === "INVALID") {
                  this.querySelector(".estimate_create_customer #shippingAddressPhoneInvalidError").style.display = "block";
                } else if (error.code === "TAKEN") {
                  this.querySelector(".estimate_create_customer #shippingAddressPhoneTakenError").style.display = "block";
                } else {
                  this.querySelector(".estimate_create_customer #shippingAddressPhoneError").innerText = error.message;
                  this.querySelector(".estimate_create_customer #shippingAddressPhoneError").style.display = "block";
                }

                if (!hasScroll) {
                  this.querySelector(".estimate_create_customer #shipping-address-phone-input").scrollIntoView({ behavior: "smooth" });
                  hasScroll = true;
                }
              } else if (error.field.indexOf("billingAddress") !== -1) {
                if (error.code === "INVALID") {
                  this.querySelector(".estimate_create_customer #billingAddressPhoneInvalidError").style.display = "block";
                } else if (error.code === "TAKEN") {
                  this.querySelector(".estimate_create_customer #billingAddressPhoneTakenError").style.display = "block";
                } else {
                  this.querySelector(".estimate_create_customer #billingAddressPhoneError").innerText = error.message;
                  this.querySelector(".estimate_create_customer #billingAddressPhoneError").style.display = "block";
                }

                if (!hasScroll) {
                  this.querySelector(".estimate_create_customer #billing-address-phone-input").scrollIntoView({ behavior: "smooth" });
                  hasScroll = true;
                }
              }
            } else if (error.field.indexOf("zip") !== -1) {
              if (error.field.indexOf("shippingAddress") !== -1) {
                if (error.code === "INVALID") {
                  this.querySelector(".estimate_create_customer #shippingAddressZipInvalidError").style.display = "block";
                } else {
                  this.querySelector(".estimate_create_customer #shippingAddressZipError").innerText = error.message;
                  this.querySelector(".estimate_create_customer #shippingAddressZipError").style.display = "block";
                }

                if (!hasScroll) {
                  this.querySelector(".estimate_create_customer #shipping-address-zip-input").scrollIntoView({ behavior: "smooth" });
                  hasScroll = true;
                }
              } else if (error.field.indexOf("billingAddress") !== -1) {
                if (error.code === "INVALID") {
                  this.querySelector(".estimate_create_customer #billingAddressZipInvalidError").style.display = "block";
                } else {
                  this.querySelector(".estimate_create_customer #billingAddressZipError").innerText = error.message;
                  this.querySelector(".estimate_create_customer #billingAddressZipError").style.display = "block";
                }

                if (!hasScroll) {
                  this.querySelector(".estimate_create_customer #billing-address-zip-input").scrollIntoView({ behavior: "smooth" });
                  hasScroll = true;
                }
              }
            } else {
              // If unhandled error, display it in final info
              this.querySelector(".account_creation_final_info").style.display = "block";
              this.querySelector(".account_creation_final_info .error_message").innerHTML += `${error.message}<br>`;
              this.querySelector(".account_creation_final_info .error_message").style.display = "block";
              this.finalCloseButton.scrollIntoView({ behavior: "smooth" });
            }
          }
        }
      } catch (error) {
        console.log(error);
        this.querySelector(".account_creation_final_info").style.display = "block";
        this.querySelector(".account_creation_final_info .server_error_message").style.display = "block";
        this.submitCustomerButton.classList.remove("is-loading");
        this.finalCloseButton.scrollIntoView({ behavior: "smooth" });
      }
    }

    // Handle submit estimate
    async submitEstimate(data) {
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }

      try {
        const response = await fetch(`${this.appURL}/draftOrder`, {
          method: "POST",
          body: formData
        });
        const result = await response.json();

        this.submitEstimateButton.classList.remove("is-loading");
        this.querySelector(".estimate_final_info").style.display = "block";

        if (result.draftOrder && result.draftOrder.id) {
          console.log(result);
          this.querySelector(".estimate_final_info .success_message").style.display = "block";
          this.submitEstimateButton.style.display = "none";
          this.finalCloseButton.scrollIntoView({ behavior: "smooth" });

          this.hasSent = true;
        } else {
          console.log(result);
          this.querySelector(".estimate_final_info .error_message").style.display = "block";
          this.finalCloseButton.scrollIntoView({ behavior: "smooth" });

          this.hasSent = true;
        }
      } catch (error) {
        console.log(error);
        this.querySelector(".estimate_final_info").style.display = "block";
        this.querySelector(".estimate_final_info .error_message").style.display = "block";
        this.finalCloseButton.scrollIntoView({ behavior: "smooth" });
        this.submitEstimateButton.classList.remove("is-loading");
      }
    }

    // Get and validate estimate form data
    getEstimateFormData(form) {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      // Check if all required fields are filled
      this.classList.remove("message-input-error");
      this.classList.remove("object-input-error");
      if (!data.object) {
        this.classList.add("object-input-error");
      }
      if (!data.message) {
        this.classList.add("message-input-error");
      }
      if (!data.object || !data.message) {
        return null;
      }

      return data;
    }
    
    // Get and validate customer form data
    getCustomerFormData(form) {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      if (data["billing_address_same_address"]) {
        data["billing_address_same_address"] = true;
      } else {
        data["billing_address_same_address"] = false;
      }

      // Make sure country is in uppercase
      data.billing_address_country = this.billingAddressCountryInput.countrySelect("getSelectedCountryData").iso2.toUpperCase();
      data.shipping_address_country = this.shippingAddressCountryInput.countrySelect("getSelectedCountryData").iso2.toUpperCase();

      if (!data.siret) {
        this.querySelector(".estimate_create_customer #siretMissingError").style.display = "block";
        this.querySelector(".estimate_create_customer #customer-siret-input").scrollIntoView({ behavior: "smooth" });
        return null;
      }

      return data;
    }

    // Populate estimate cart item with cart content
    populateEstimateCartItem(event) {
      setTimeout(this.addCartOpenEstimateEvent.bind(this), 500);
      setTimeout(this.addCartPageOpenEstimateEvent.bind(this), 500);
      this.estimateCartProductWrapper.innerHTML = "";
      let i = 1;
      for (const item of event.detail.cart.items) {
        const itemHtml = this.createHTMLItem(item, i);
        this.estimateCartProductWrapper.insertAdjacentHTML("beforeend", itemHtml);
        i++;
      }
    }
  }

  customElements.define('custom-estimate', CustomEstimate);
}